import { IDQRSEIBreakDetail } from 'api/seibreakdetail.types'
import { createListsStore } from 'features/Lists/core/store'
import { hookDefinitions } from 'features/Lists/hooks/useList'
import {
  createDefaultColumnState,
  mapColumnsToFilterDefinitions
} from 'features/Lists/shared/lists'
import { partial } from 'lodash/fp'
import { AppState } from 'store/shared/contracts'
import { formatReconStatusLabel } from '../../common/Utility'
import { SEIColumnDefinitions } from '../ColumnDefinitions'

export const constructInitialSEIColumnState = partial(
  createDefaultColumnState,
  [SEIColumnDefinitions]
)

export const SEIListStore = createListsStore<IDQRSEIBreakDetail>(
  'dqrseibreakdetail',
  '@features/@lists/@dqrseibreakdetail',
  {
    columnDefinitions: SEIColumnDefinitions,
    filterDefinitions: mapColumnsToFilterDefinitions(SEIColumnDefinitions)
  },
  (state: AppState) => state.features.lists.dqrSeiBreakDetail,
  undefined,
  { summaryStatus: formatReconStatusLabel }
)

export const { reducer, sagas, actions, selectors } = SEIListStore

// Register the recon list type with the core Lists system
hookDefinitions.sei = {
  listType: 'sei',
  columnDefinitions: SEIColumnDefinitions,
  actions,
  selectors
}
